// extracted by mini-css-extract-plugin
module.exports = {"width":"strategy_width__RZxEH","hero-text":"strategy_hero-text__OoeO4","wrapper":"strategy_wrapper__qDW73","split":"strategy_split__OLIJi"};